import pathToRegexp from 'path-to-regexp'

class Route {
  constructor(pathExpression, Component, params = {}){
    this.pathExpression = pathExpression
    this.Component = Component
    this.params = params
    this.keys = []
    this.regexp = pathToRegexp(pathExpression, this.keys)
  }

  match(pathname){
    const matches = this.regexp.exec(pathname)
    if (!matches) return false
    const params = {...this.params}
    this.keys.forEach((key, index) => {
      params[key.name] = matches[index + 1]
    })
    return {
      Component: this.Component,
      params,
    }
  }
}

export default class PathnameRouter {
  constructor(callback){
    this.routes = []
    const map = (...args) => {
      this.routes.push(
        new Route(...args)
      )
    }
    callback(map)
  }

  resolve(pathname){
    let resolvedRoute
    this.routes.find(route => // eslint-disable-line no-return-assign
      resolvedRoute = route.match(pathname)
    )
    if (resolvedRoute) return {
      Component: resolvedRoute.Component,
      params: {...resolvedRoute.params},
    }
  }
}
